import { render, staticRenderFns } from "./getCustomers.vue?vue&type=template&id=2298e13a&scoped=true"
import script from "./getCustomers.vue?vue&type=script&lang=js"
export * from "./getCustomers.vue?vue&type=script&lang=js"
import style0 from "./getCustomers.vue?vue&type=style&index=0&id=2298e13a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298e13a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2298e13a')) {
      api.createRecord('2298e13a', component.options)
    } else {
      api.reload('2298e13a', component.options)
    }
    module.hot.accept("./getCustomers.vue?vue&type=template&id=2298e13a&scoped=true", function () {
      api.rerender('2298e13a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/getCustomers.vue"
export default component.exports